

















import { createComponent } from "@vue/composition-api";
import ResourceItemTable from "@/components/resource/ResourceItemTable.vue";
import { languageResource } from "@megarax/client/src/resources/plm";
import { Resource } from "@megarax/client/src";
import { ListActions } from "@megarax/client/src/list";

interface Props {
  resource: Resource<ListActions<any>>;
}

export default createComponent<Props>({
  components: { ResourceItemTable },
  props: {
    resource: { required: true },
  },
  setup(props, ctx) {
    return {};
  },
});
